import React, { useState, useEffect } from "react";
import checkIcon from "../assets/checkIcon.png"
import UploadCV from "../components/Upload/UploadCV";
import UploadMotivationLetter from "../components/Upload/UploadMotivationLetter"
import LinkedInProfile from '../components/Upload/LinkedInProfile'
import CareerPreferencesStep from "../components/Upload/CareerPreferencesStep";
import ReflectionStep from "../components/Upload/ReflectionStep";
import { gsap } from 'gsap';
import useJobRoles from "../hooks/useJobRoles";
import closeIcon from "../assets/close-icon.png";
import Cookies from 'js-cookie';

const translations = {
  en: {
    uploadCV: "Upload CV",
    uploadMotivationLetter: "Upload Motivational Letter",
    linkedInProfile: "LinkedIn Profile",
    careerPreferences: "Career Preferences",
    reflection: "Reflection",
    uploading: "Uploading",
    uploadComplete: "Upload Complete!",
    analyzingLinkedIn: "Analyzing LinkedIn Profile..."
  },
  nl: {
    uploadCV: "CV Uploaden",
    uploadMotivationLetter: "Motivatiebrief Uploaden",
    linkedInProfile: "LinkedIn Profiel",
    careerPreferences: "Carrière Voorkeuren",
    reflection: "Reflectie",
    uploading: "Uploaden",
    uploadComplete: "Upload Voltooid!",
    analyzingLinkedIn: "LinkedIn Profiel Analyseren..."
  }
};

function Upload({ setCVFile, setMLetterFile, setLinkedInURL, cvFile, mLetterfile, linkedInURL, linkedInData, setLinkedInData,
  uploadProgress, setUploadProgress, uploadComplete, setUploadComplete, uploading, setUploading, isDragging, setIsDragging,
  uploadMLetterProgress, setUploadMLetterProgress, uploadMLetterComplete, setUploadMLetterComplete, uploadMLetterUploading, setUploadMLetterUploading, uploadMLetterIsDragging, setUploadMLetterIsDragging,
  preferencesSummary, setPreferencesSummary,
  reflectionSummary, setReflectionSummary, reflectionAnswers, setReflectionAnswers,
  mLetterOption, setMLetterOption, mLetterText, setMLetterText,
  isDutch,
  careerPreferences, setCareerPreferences,
  reflection, setReflection
}) {

  const [activeIndicator, setActiveIndicator] = useState(1);
  const [isCareerFormValid, setIsCareerFormValid] = useState(false);
  const [isReflectionFormValid, setIsReflectionFormValid] = useState(false);
  const t = translations[isDutch ? 'nl' : 'en'];
  
  let uploadInterval;
  let uploadMLetterInterval;

  const [indicators, setIndicators] = useState([
    {
      id: 1,
      title: t.uploadCV,
    },
    {
      id: 2,
      title: t.linkedInProfile
    },
    {
      id: 3,
      title: t.careerPreferences
    },
    {
      id: 4,
      title: t.reflection
    }
  ]);

  useEffect(() => {
    setIndicators([
      {
        id: 1,
        title: t.uploadCV,
      },
      {
        id: 2,
        title: t.linkedInProfile
      },
      {
        id: 3,
        title: t.careerPreferences
      },
      {
        id: 4,
        title: t.reflection
      }
    ]);
  }, [isDutch, t]);

  const jobRoles = useJobRoles();

  const isStepCompleted = (id) => {
    switch (id) {
      case 1:
        return cvFile !== null;
      case 2:
        return linkedInURL !== '';
      case 3:
        return isCareerFormValid;
      case 4:
        return isReflectionFormValid;
      default:
        return false;
    }
  };

  const [isLinkedInLoading, setIsLinkedInLoading] = useState(false);
  const [linkedInprogress, setLinkedInProgress] = useState(0);

  const [showUploadProgress, setShowUploadProgress] = useState(false);
  const [showUploadMLetterProgress, setShowUploadMLetterProgress] = useState(false);
  
  const uploadComponents = [
    <UploadCV
      setActiveIndicator={setActiveIndicator}
      cvFile={cvFile}
      setCVFile={setCVFile}
      uploadProgress={uploadProgress}
      setUploadProgress={setUploadProgress}
      uploadComplete={uploadComplete}
      setUploadComplete={setUploadComplete}
      uploading={uploading}
      setUploading={setUploading}
      isDragging={isDragging}
      setIsDragging={setIsDragging}
      uploadInterval={uploadInterval}
      setShowUploadProgress={setShowUploadProgress}
    />,
    // <UploadMotivationLetter
    //   setActiveIndicator={setActiveIndicator}
    //   mLetterfile={mLetterfile}
    //   setMLetterFile={setMLetterFile}
    //   uploadProgress={uploadMLetterProgress}
    //   setUploadProgress={setUploadMLetterProgress}
    //   uploadComplete={uploadMLetterComplete}
    //   setUploadComplete={setUploadMLetterComplete}
    //   uploadMLetterUploading={uploadMLetterUploading}
    //   setUploadMLetterUploading={setUploadMLetterUploading}
    //   isDragging={uploadMLetterIsDragging}
    //   setIsDragging={setUploadMLetterIsDragging}
    //   setShowUploadMLetterProgress={setShowUploadMLetterProgress}
    //   uploadMLetterInterval={uploadMLetterInterval}
    //   mLetterOption={mLetterOption}
    //   setMLetterOption={setMLetterOption}
    //   mLetterText={mLetterText}
    //   setMLetterText={setMLetterText}
    // />, 
    <LinkedInProfile
      setActiveIndicator={setActiveIndicator}
      linkedInURL={linkedInURL}
      setLinkedInURL={setLinkedInURL}
      cvFile={cvFile}
      mLetterfile={mLetterfile}
      linkedInData={linkedInData}
      setLinkedInData={setLinkedInData}
      setProgress={setLinkedInProgress}
      progress={linkedInprogress}
      isLoading={isLinkedInLoading}
      setIsLoading={setIsLinkedInLoading}
      isDutch={isDutch}
    />,
    <CareerPreferencesStep setActiveIndicator={setActiveIndicator}
    preferencesSummary={preferencesSummary} setPreferencesSummary={setPreferencesSummary}
    isCareerFormValid={isCareerFormValid}
    setIsCareerFormValid={setIsCareerFormValid}
    isDutch={isDutch}
    setCareerPreferences={setCareerPreferences}
    />,
    <ReflectionStep setActiveIndicator={setActiveIndicator}
    reflectionSummary={reflectionSummary} setReflectionSummary={setReflectionSummary} reflectionAnswers={reflectionAnswers} setReflectionAnswers={setReflectionAnswers}
    isReflectionFormValid={isReflectionFormValid}
    setIsReflectionFormValid={setIsReflectionFormValid}
    isDutch={isDutch}
    setReflection={setReflection}
    />]

  useEffect(() => {
    // Helper functions for GSAP performance optimization
    const setGSAPProperties = (element, props) => {
      if (props.force3D) {
        element.style.transform = 'translate3d(0, 0, 0)';
      }
      if (props.willChange) {
        element.style.willChange = props.willChange;
      }
    };

    const resetGSAPProperties = (element) => {
      element.style.willChange = 'auto';
    };

    // Direct fadeUp animation
    const initFadeUp = () => {
      const fadeUpElements = document.querySelectorAll(".fadeUp");

      if (fadeUpElements.length === 0) {
        setTimeout(initFadeUp, 100);
        return;
      }

      // Set CSS properties directly for better performance
      fadeUpElements.forEach(element => {
        setGSAPProperties(element, { force3D: true, willChange: "transform, opacity" });
      });

      const animationDelay = 0; // Base delay in milliseconds

      gsap.set(fadeUpElements, { 
        opacity: 0, 
        y: 20
      });
      
      gsap.to(fadeUpElements, {
        opacity: 1,
        y: 0,
        duration: 0.6,
        delay: 0.2 + (animationDelay / 1000), // Add navbar delay to base delay
        stagger: 0.1,
        ease: "power2.out",
        onComplete: () => {
          // Reset CSS properties after animation
          fadeUpElements.forEach(element => {
            resetGSAPProperties(element);
          });
        }
      });
    };

    initFadeUp();
  }, []);

  useEffect(() => {
    if (uploadComplete) {
      const timer = setTimeout(() => {
        setShowUploadProgress(false);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [uploadComplete]);

  useEffect(() => {
    if (uploadMLetterComplete) {
      const timer = setTimeout(() => {
        setShowUploadMLetterProgress(false);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [uploadMLetterComplete]);

  return (
    <div className="flex flex-1 justify-between flex-col upload">
      <div>
        <div className="flex-wrap mt-8 flex gap-4 justify-center">
          {indicators.map((indicator, index) => {
            const isCompleted = isStepCompleted(indicator.id);
            return (
              <div className="fadeUp" key={indicator.id}>
                <div
                key={indicator.id} className={`truncate flex gap-2 items-center ${indicator.id === activeIndicator ? "opacity-100" : "opacity-50"}`}>
                  <span className={`truncate w-14 h-14 rounded-full flex items-center justify-center ${indicator.id === activeIndicator ? "gradient-bg-3" : "gradient-bg-2"}`}>
                    {isCompleted ? (
                      <img src={checkIcon} className="w-8 h-8" alt="completed" />
                    ) : (
                      <p className={`font-bold ${indicator.id !== activeIndicator ? "text-primary" : "text-white"}`}>
                        {indicator.id}
                      </p>
                    )}
                  </span>
                  <span className="truncate text-sm">{indicator.title}</span>
                </div>
              </div>
            )
          })}
        </div>
        <div className="mt-16 fadeUp">
          {uploadComponents[activeIndicator - 1]}
        </div>

      </div>
      {cvFile && showUploadProgress && (
        <div className='loading-status p-4 px-12 border shadow-md w-3/5 mx-auto rounded-full'>
      {cvFile && <p className='font-bold text-center mb-2'>{` ${!uploadComplete ? `${t.uploading} ${cvFile?.name} ...` : t.uploadComplete} `}</p>}
      <div className='flex gap-2 items-center'>
      <div className="relative w-full h-2 bg-[#E0E0E0] rounded-full">
        <div
          className="absolute h-full gradient-bg-3 transition-all duration-300 rounded-full"
          style={{ width: `${uploadProgress}%` }}
        />
      </div>
      <span>{uploadProgress}%</span>
      </div>
      
      </div>
      )}
        {mLetterfile && showUploadMLetterProgress && (
        <div className='loading-status p-4 px-12 border shadow-md w-3/5 mx-auto rounded-full'>
          {mLetterfile && <p className='font-bold text-center mb-2'>{` ${!uploadMLetterComplete ? `${t.uploading} ${mLetterfile?.name} ...` : t.uploadComplete} `}</p>}
          <div className='flex gap-2 items-center'>
          <div className="relative w-full h-2 bg-[#E0E0E0] rounded-full">
              <div
                className="absolute h-full gradient-bg-3 transition-all duration-300 rounded-full"
                style={{ width: `${uploadMLetterProgress}%` }}
              />
            </div>
            <span>{uploadMLetterProgress}%</span>
          </div>

        </div>
      )}
      {isLinkedInLoading && (
        <div className='loading-status p-4 px-12 border shadow-md w-3/5 mx-auto rounded-full'>
          <p className='font-bold text-center mb-2'>{t.analyzingLinkedIn}</p>
          <div className='flex gap-2 items-center'>
            <div className="relative w-full h-2 bg-[#E0E0E0] rounded-full">
              <div
                className="absolute h-full gradient-bg-3 transition-all duration-300 rounded-full"
                style={{ width: `${linkedInprogress}%` }}
              />
            </div>
            <span>{linkedInprogress}%</span>
          </div>
        </div>
      )}
    </div>
  );
}

export default Upload; 